<!-- TODO  needs discussion: is this file deprecated? - @andre.lorch -->

<template lang="html">
  <div class="splash">
    <NavBar titleTranslationPath="loginOptions.title" :back="true" />
    <Logo />
    <div class="options">
      <Button class="button" color="white" center="center" @click.native="$router.push({ name: $namedRoutes.login })">
        <NewTranslation path="loginOptions.byMail" />
        <font-awesome-icon icon="envelope" slot="icon" />
      </Button>
      <Button class="button" color="white" center="center"><NewTranslation path="loginOptions.byVerimi"/></Button>
      <Button
        class="button"
        color="white"
        center="center"
        @click.native="$router.push({ name: $namedRoutes.benefitsOverview })"
      >
        <NewTranslation path="loginOptions.asGuest" />
      </Button>
    </div>
    <div class="changetologin" @click="$router.push({ name: $namedRoutes.register })">
      <NewTranslation path="loginOptions.switchReg" />
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import Button from '@/components/Button.vue';
import Logo from '@/components/Logo.vue';
import NewTranslation from '@/components/i18n/NewTranslation';

export default {
  components: {
    NewTranslation,
    NavBar,
    Button,
    Logo,
  },
};
</script>

<style lang="sass" scoped>
.splash
	min-height: 100vh
	height: 100%
	background-image: url(../../assets/splash.png)
	background-position: center center
	display: flex
	flex-direction: column
	align-items: center
	color: #fff
	padding: 0 20px 50px
.pagetitle
	margin-top: 50px
.appicon
	margin-top: 70px
	width: 30px
	height: 40px
.options
	width: 100%
	margin-top: 130px
.changetologin
	margin-top: 40px
	text-decoration: underline
</style>
